import * as $ from 'jquery';
import AnimationEasing from '../lib/AnimationEasing';

export default function DownArrow() {
	$('.arrowToContent').on('click', function(e) {
		e.preventDefault();

		// Determine where to scroll to
		const target = <HTMLAnchorElement>this;
		const selector = target.href.substring(target.href.indexOf('#'));
		const scrollTop = $(selector).offset().top - 20;

		// Scroll
		$('html, body').animate({scrollTop: scrollTop}, 500, <any>AnimationEasing.func.easeOutCubic);
	});
}
